import type { IconData } from '@stacksjs/iconify-core'

export const drumStick: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M40.154 28.263c-7.047 7.047-19.724 10.583-25.362 4.945S12.69 14.893 19.737 7.846c7.048-7.048 14.939-5.798 20.577-.16s6.888 13.53-.16 20.577\"/><path d=\"m12.86 30.249l-3.024 4.23c-.359.501-1.085.548-1.639.275a3.608 3.608 0 1 0-2.675 6.68a1.61 1.61 0 0 1 1.039 1.039a3.61 3.61 0 1 0 6.682-2.67c-.271-.553-.224-1.277.277-1.636l4.23-3.027m16.46-9.595c-3.241 3.241-8.55 5.192-12.21 4.191\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default drumStick
